/**
 * @description fetch all pricing items
 * @param currency
 */

import type { ICreditPackPayload, IStripePayload } from '../types'

export const fetchPricingItemsApi = async (currency: string, cycle: string, type: 'enterprise' | 'personal') => {
    return await useApi().get(`${`/payment/plans/${type}?cycle=${cycle}&currency=${currency.toLowerCase()}`}`)
}

export const getStripeLinkApi = async (payload: IStripePayload, locale: string) => {
    const options: { body: IStripePayload; headers?: { [key: string]: string } } = {
        body: payload
    }
    if (locale !== 'en') {
        options.headers = { locale }
    }

    return await useApi().post('/payment/subscribe', options)
}

export const submitCreditPackApi = async (payload: ICreditPackPayload, locale: string) => {
    const options: { body: ICreditPackPayload; headers?: { [key: string]: string } } = {
        body: payload
    }
    if (locale !== 'en') {
        options.headers = { locale }
    }

    return await useApi().post('/payment/input-pack', options)
}

export const fetchModalData = async (planId: string, currency: string, quantity?: number) => {
    return await useApi().get(
        `payment/preview?plan_id=${planId}&currency=${currency}${quantity ? `&quantity=${quantity}` : ''}`
    )
}
